export const SESSION_TYPE_CONFIG = {
  infrared: {
    displayName: "Infrared Sauna Session",
    shortDisplayName: "Infrared sauna",
    bookingLabel: "50 Min Infrared Sauna Session",
    suiteLabel: "Sauna Suite",
    serviceName: "infrared sauna",
    isMassage: false,
    price: null,
  },
  redlight: {
    displayName: "Red Light Bed Session",
    shortDisplayName: "Red light bed",
    bookingLabel: "20 Min Red Light Bed Session",
    suiteLabel: "Red Light Bed Suite",
    serviceName: "red light",
    isMassage: false,
    price: null,
  },
  massage_60: {
    displayName: "60 Minute Massage",
    shortDisplayName: "60 minute massage",
    bookingLabel: "60 Minute Massage",
    suiteLabel: "Massage Suite",
    serviceName: "massage",
    isMassage: true,
  },
  massage_90: {
    displayName: "90 Minute Massage",
    shortDisplayName: "90 minute massage",
    bookingLabel: "90 Minute Massage",
    suiteLabel: "Massage Suite",
    serviceName: "massage",
    isMassage: true,
  },
};

export const isMassageSessionType = (sessionType) =>
  Boolean(SESSION_TYPE_CONFIG[sessionType]?.isMassage);

export const getSessionDisplayName = (sessionType) =>
  SESSION_TYPE_CONFIG[sessionType]?.displayName || "Session";

export const getSessionShortDisplayName = (sessionType) =>
  SESSION_TYPE_CONFIG[sessionType]?.shortDisplayName || "session";

export const getBookingOptionLabel = (sessionType) =>
  SESSION_TYPE_CONFIG[sessionType]?.bookingLabel || "Session";

export const getSessionSuiteLabel = (sessionType) =>
  SESSION_TYPE_CONFIG[sessionType]?.suiteLabel || "Suite";

export const getSessionServiceName = (sessionType) =>
  SESSION_TYPE_CONFIG[sessionType]?.serviceName || "session";

